import { render, staticRenderFns } from "./BannerMtLink.vue?vue&type=template&id=5f0ad38a&scoped=true&"
import script from "./BannerMtLink.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BannerMtLink.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BannerMtLink.vue?vue&type=style&index=0&id=5f0ad38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ad38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0ad38a')) {
      api.createRecord('5f0ad38a', component.options)
    } else {
      api.reload('5f0ad38a', component.options)
    }
    module.hot.accept("./BannerMtLink.vue?vue&type=template&id=5f0ad38a&scoped=true&", function () {
      api.rerender('5f0ad38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BannerMtLink/BannerMtLink.vue"
export default component.exports